export default "__VITE_ASSET__CgvGssER__"